import { render, staticRenderFns } from "./NonAsciiAlert.vue?vue&type=template&id=f44b4f44&"
import script from "./NonAsciiAlert.vue?vue&type=script&lang=js&"
export * from "./NonAsciiAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports